import React from 'react';
import WrapperValidationInputGroup from "./WrapperValidationInputGroup";
import PropTypes from "prop-types";
import {RequiredValidator} from "../../validator/RequiredValidators";
import {CreditCardNumberValidator} from "../../validator/CreditCardValidators";
import {MaximumLengthValidator, MinimunLengthValidator} from "../../validator/LengthValidators";
import {ImageMaskInputGroup} from "../base/ImageMaskInputGroup";
import VisaFlag from "../../img/visa.png";
import MasterFlag from "../../img/master.png";
import AmexFlag from "../../img/amex.png";
import EloFlag from "../../img/elo.png";
import DinersFlag from "../../img/diners.png";
import AuraFlag from "../../img/aura.png";
import JcbFlag from "../../img/jcb.png";
import DiscoverFlag from "../../img/discover.png";
import HipercardFlag from "../../img/hipercard.png";
import {CreditCardControl} from "../../utils/CreditCardControl";

class CreditCardMask extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            image: {src: "", alt: ""},
            mask: "000000000000000000000000000000000000"
        };
    }

    handleChange(e) {
        const value = e.target ? e.target.value : e;
        this.props.onChange(value);
        const flags = this.props.flags || {
          mastercard: {
              image: MasterFlag
          },
          master: {
              image: MasterFlag
          },
          visa: {
              image: VisaFlag
          },
          amex: {
              image: AmexFlag
          },
          elo: {
              image: EloFlag
          },
          diners: {
            image: DinersFlag
          },
          hipercard: {
            image: HipercardFlag
          },
          aura: {
            image: AuraFlag
          },
          discovery: {
            image: DiscoverFlag
          },
          jcb: {
            image: JcbFlag
          },
          none: {
            image: ""
          }
        };
        const ccControl = new CreditCardControl();
        const card = ccControl.getCard(value);
        let state = Object.assign(this.state);
        state.image.src = card !== undefined ? flags[card.flag].image : "";
        state.image.alt = card !== undefined ? card.flag : "";
        state.mask = card !== undefined ? card.mask : "000000000000000000000000000000000000";
        this.setState(state);
    }

    render() {
        return (
            <ImageMaskInputGroup autoFocus={this.props.autoFocus} input={this.props.input} mask={this.state.mask} image={this.state.image}
                                 alert={this.props.alert} onChange={this.handleChange} onBlur={this.props.onBlur}/>
        )
    }
}

let listValidators = () => {
    let validators = [];
    validators.push(new RequiredValidator());
    validators.push(new MinimunLengthValidator("", 14));
    validators.push(new MaximumLengthValidator("", 16));
    validators.push(new CreditCardNumberValidator());
    return validators;
};

const validators = {
    validators: listValidators(),
};

export const CreditCardNumberInputGroup = WrapperValidationInputGroup(CreditCardMask, validators);

CreditCardNumberInputGroup.propTypes = {
    alert: PropTypes.shape({
        show: PropTypes.bool.isRequired,
        title: PropTypes.string,
        text: PropTypes.string,
        type: PropTypes.string,
        dismissible: PropTypes.bool,
        handleMessage: PropTypes.func
    }),
    input: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string,
        disabled: PropTypes.bool,
        type: PropTypes.string,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        title: PropTypes.string,
    }).isRequired,
    validateOn: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    flags: PropTypes.object
};


// WEBPACK FOOTER //
// ./src/input/validation/CreditCardNumberInputGroup.js